import Vue from 'vue';
import GroupAdminVue from "./Group_Admin.vue";
import GroupData from "./components/GroupData.vue";
import GroupAdministrators from "./components/GroupAdministrators.vue";
import GroupPersons from "./components/GroupPersons.vue";
import GroupEdit from "./components/GroupEdit.vue";
import SelectPersons from './components/GroupSelectperson.vue';
import flatPicker from 'vue-flatpickr-component';
import VueUploadComponent from 'vue-upload-component';

export default class GroupManager {

    static init() {
        const els = document.querySelectorAll('.asd-group');
        if (!els) {
            console.log('no els',els);
            return;
        }
        els.forEach( el => {
            const act_id = el.getAttribute('data-group',0);
            if (parseInt(act_id) > 0) {
                try {
                    new GroupManager(el, parseInt(act_id));
                }
                catch (e) { console.log(e) }
            } else {
                console.log('Error initiating GroupAdmin');
            }

        })
    }

    /**
     *
     * @param el Node
     * @param act_id number
     */
    constructor(el, act_id) {
        this.el = el;
        this.act_id = act_id;

        Vue.component('GroupAdmin', GroupAdminVue);
        Vue.component('GroupData', GroupData);
        Vue.component('GroupPersons', GroupPersons);
        Vue.component('GroupAdministrator', GroupAdministrators);
        Vue.component('GroupSelectperson', SelectPersons);
        Vue.component('GroupEdit', GroupEdit);
        Vue.component('FlatPickr', flatPicker);
        Vue.component('file-upload', VueUploadComponent)

        let component = Vue.extend(GroupAdminVue);
        new component ({
            el: el,
            propsData: {
                group_id: act_id,
                isGroupAdmin: window.asdProfileType === 'group'
            },
            // components: {
            //     'GroupAdmin': GroupAdminVue,
            //     'GroupData': GroupData,
            //     'GroupPersons': GroupPersons,
            //     'GroupEdit': GroupEdit,
            // },
        })
    }
}
